export enum ProblemType {
  ImperfectCallQuality = 'imperfect-audio-quality',
  DroppedCall = 'dropped-call',
  IncorrectCallerId = 'incorrect-caller-id',
  PostCallDelay = 'post-call-delay',
  AudioLatency = 'audio-latency',
  OneWayAudio = 'one-way-audio',
}
